// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"b06c9aa6","787":"e4b321cc","848":"b973d770"}[chunkId] + ".chunk.js";
};